var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-info-cupo"},[_c('div',{staticClass:"container-max-width w-100"},[_c('info-cupo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }